import { RestService } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { AppSettingsDto, UpdateAppSettingsDto, ColumnListPreferences, UpdateColumnListPreferencesInput, DashboardTabSettingsDto, UpdateDashboardTabSettingsDto } from './models';

@Injectable({
  providedIn: 'root',
})
export class AppSettingsService {
  apiName = 'SettingManagement';

  get = () =>
    this.restService.request<any, AppSettingsDto>(
      {
        method: 'GET',
        url: '/api/setting-management/app',
      },
      { apiName: this.apiName }
    );

  update = (input: UpdateAppSettingsDto) =>
    this.restService.request<any, void>(
      {
        method: 'POST',
        url: '/api/setting-management/app',
        body: input,
      },
      { apiName: this.apiName }
    );

  getFlespiAccountId = () =>
    this.restService.request<any, { id: string; flespiId: number; embedUrl: string }>(
      {
        method: 'GET',
        url: '/api/register/assets/account',
      },
      { apiName: this.apiName }
    );

  getAssetListPreferences = () =>
    this.restService.request<any, ColumnListPreferences>(
      {
        method: 'GET',
        url: '/api/setting-management/user-preferences/assets',
      },
      { apiName: this.apiName }
    );

  setAssetListPreferences = (input: UpdateColumnListPreferencesInput) =>
    this.restService.request<any, ColumnListPreferences>(
      {
        method: 'POST',
        url: '/api/setting-management/user-preferences/assets',
        body: input,
      },
      { apiName: this.apiName }
    );

  getInspectionListPreferences = () =>
    this.restService.request<any, ColumnListPreferences>(
      {
        method: 'GET',
        url: '/api/setting-management/user-preferences/inspections',
      },
      { apiName: this.apiName }
    );

  setInspectionListPreferences = (input: UpdateColumnListPreferencesInput) =>
    this.restService.request<any, ColumnListPreferences>(
      {
        method: 'POST',
        url: '/api/setting-management/user-preferences/inspections',
        body: input,
      },
      { apiName: this.apiName }
    );

  constructor(private restService: RestService) {}

  getDashboardTabSettings = () =>
    this.restService.request<any, DashboardTabSettingsDto>(
      {
        method: 'GET',
        url: '/api/setting-management/dashboard-tabs',
      },
      { apiName: this.apiName }
    );

  updateDashboardTabSettings = (input: UpdateDashboardTabSettingsDto) =>
    this.restService.request<any, void>(
      {
        method: 'POST',
        url: '/api/setting-management/dashboard-tabs',
        body: input,
      },
      { apiName: this.apiName }
    );
}
